import httpClientService from '@/services/httpClientService';

export default {
	getAllProjects: () =>
		httpClientService.Get('/ProjectManagementModule/api/ProjectManagement'),
	getByIdProject: (id) =>
		httpClientService.Get(
			'/ProjectManagementModule/api/ProjectManagement/' + id
		),
	createIntegrationApiKey: (id) =>
		httpClientService.Put(
			'/ProjectManagementModule/api/ProjectManagement/CreateIntegrationApiKey?id=' +
				id
		),
	insertProject: (param) =>
		httpClientService.PostMultiPart(
			'/ProjectManagementModule/api/ProjectManagement',
			param
		),
	updateProject: (param, id) =>
		httpClientService.PutMultiPart(
			`/ProjectManagementModule/api/ProjectManagement/${id}`,
			param
		),
	deleteProject: (id) =>
		httpClientService.Delete(
			'/ProjectManagementModule/api/ProjectManagement/' + id
		),
	removeProjectLogo: (projectId) =>
		httpClientService.Put(
			`/ProjectManagementModule/api/ProjectManagement/${projectId}/removeLogo`
		),

	getMobileAccessCodes: (projectId) =>
		httpClientService.Get(
			`/ProjectManagementModule/api/MobileAccess/${projectId}/codes`
		),
	generateMobileAccessCode: (param) =>
		httpClientService.Post(
			'/ProjectManagementModule/api/MobileAccess/codes',
			param
		),
	revokeMobileAccessCode: (id) =>
		httpClientService.Put(
			`/ProjectManagementModule/api/MobileAccess/codes/${id}/revoke`
		),
	getMobileDevices: (projectId) =>
		httpClientService.Get(
			`/ProjectManagementModule/api/MobileAccess/${projectId}/devices`
		),
	setMobileDeviceStatus: (id, status) =>
		httpClientService.Put(
			`/ProjectManagementModule/api/MobileAccess/devices/${id}/status?status=${status}`
		),

	getAllProjectsDbCon: () =>
		httpClientService.Get('/ProjectManagementModule/api/DbConnection'),
	getDbByName: (name) =>
		httpClientService.Get(
			'/ProjectManagementModule/api/DbConnection/GetByName?name=' + name
		),
	getByIdProjectDbCon: (id) =>
		httpClientService.Get(
			'/ProjectManagementModule/api/DbConnection/' + id
		),
	insertProjectDbCon: (param) =>
		httpClientService.Post(
			'/ProjectManagementModule/api/DbConnection',
			param
		),
	updateProjectDbCon: (param) =>
		httpClientService.Put(
			'/ProjectManagementModule/api/DbConnection',
			param
		),
	deleteProjectDbCon: (id) =>
		httpClientService.Delete(
			'/ProjectManagementModule/api/DbConnection/' + id
		),
};
